import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleTecnical } from "../hooks/roles/ProtectedRoleTecnical";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";

const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleEstimar = React.lazy(
  () =>
    import(
      "../components/task/tecnical/tareaDetalleEstimar/tarea-detalle-estimar"
    )
);
export function tareaDetalleEstimar() {
  return (
    <Route
      path="/tarea-detalle-estimar"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleTecnical>
              <LazySuspense>
                <TareaDetalleEstimar />
              </LazySuspense>
            </ProtectedRoleTecnical>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
